export const RELEASE_NOTES = [
  {
    version: 'v2.1.0',
    date: '23rd October 2026',
    notes: [
      'Added a Release Notes feature to provide users with a summary of updates following each release for analyst.',
      'Enhanced login security and authentication with improved encryption mechanisms.',
      'Displayed the status code in audit log screen.'
    ],
    isLatest: true
  },
  {
    version: 'v2.0.0',
    date: '8th September 2026',
    notes: [
      'Implemented the suspicious event customer locations search functionality.',
      'Implemented Markets of concern analytics graph functionality.',
      'Displayed the error messages when BE api error or any network/timeout issues in Chat modal.',
      'Fixed the conversation id null issue in Chat modal.'
    ],
    isLatest: false
  }
];
export const getReleaseNotes = () => RELEASE_NOTES;
export const getLatestRelease = () => RELEASE_NOTES[0] || null;
